module.exports = __webpack_public_path__ + "img/img-6.96bcf519.webp";